import { render } from "./Label.vue?vue&type=template&id=6d788ba8&ts=true"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__